import { UntypedFormGroup, UntypedFormControl, FormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class UserJsVm {
	id: number;
	firstName?: string;
	lastName?: string;
	canChangeSecurity: boolean;
	inactivityTimeout: boolean;
	twoFactorEnabled: boolean;
	canChangeClient: boolean;
	securityAccessDate?: Date;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'id': new UntypedFormControl(0, [...(validators['id'] ?? []), ...[Validators.required]]),
			'firstName': new UntypedFormControl(null, [...(validators['firstName'] ?? []), ...[]]),
			'lastName': new UntypedFormControl(null, [...(validators['lastName'] ?? []), ...[]]),
			'canChangeSecurity': new UntypedFormControl(false, [...(validators['canChangeSecurity'] ?? []), ...[]]),
			'inactivityTimeout': new UntypedFormControl(false, [...(validators['inactivityTimeout'] ?? []), ...[]]),
			'twoFactorEnabled': new UntypedFormControl(false, [...(validators['twoFactorEnabled'] ?? []), ...[]]),
			'canChangeClient': new UntypedFormControl(false, [...(validators['canChangeClient'] ?? []), ...[]]),
			'securityAccessDate': new UntypedFormControl(null, [...(validators['securityAccessDate'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): UserJsVmFromFg {
		return new UserJsVmFromFg(fg);
	}
}

export class UserJsVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get id(): number {
		return this.fg.get('id').value;
	}
	set id(val) {
		this.fg.get('id').setValue(val);
	}

	get firstName(): string {
		return this.fg.get('firstName').value;
	}
	set firstName(val) {
		this.fg.get('firstName').setValue(val);
	}

	get lastName(): string {
		return this.fg.get('lastName').value;
	}
	set lastName(val) {
		this.fg.get('lastName').setValue(val);
	}

	get canChangeSecurity(): boolean {
		return this.fg.get('canChangeSecurity').value;
	}
	set canChangeSecurity(val) {
		this.fg.get('canChangeSecurity').setValue(val);
	}

	get inactivityTimeout(): boolean {
		return this.fg.get('inactivityTimeout').value;
	}
	set inactivityTimeout(val) {
		this.fg.get('inactivityTimeout').setValue(val);
	}

	get twoFactorEnabled(): boolean {
		return this.fg.get('twoFactorEnabled').value;
	}
	set twoFactorEnabled(val) {
		this.fg.get('twoFactorEnabled').setValue(val);
	}

	get canChangeClient(): boolean {
		return this.fg.get('canChangeClient').value;
	}
	set canChangeClient(val) {
		this.fg.get('canChangeClient').setValue(val);
	}

	get securityAccessDate(): Date {
		return this.fg.get('securityAccessDate').value;
	}
	set securityAccessDate(val) {
		this.fg.get('securityAccessDate').setValue(val);
	}
}
